import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../../../theme/style-helpers';
import ChevronDown from '../../../../assets/icons/chevron_down_icon.svg';
import ChevronRight from '../../../../assets/icons/chevron_right_icon.svg';
import Search from '../../../../assets/icons/Search.svg';
import x_icon from '../../../../assets/icons/x_icon.svg';

export const Container = styled.div`
    display: grid;
    grid-auto-flow: row;
    row-gap: 8px;
    grid-auto-rows: max-content;
    width: 100%;
`;

export const Label = styled.label`
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin: 0;

    &.panel-label {
        padding: 12px 20px;
        font-weight: 600;
        font-size: 1.6rem;
        line-height: 150%;
        color: ${colors.BLACK};
        margin: 0;
        display: block;
        width: 100%;
        border: none;
        text-align: left;
        text-transform: capitalize;
    }
`;

export const Selected = styled.p`
    padding: 12px 16px;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    margin: 0;
    color: ${({ hasPlaceholder }) => (hasPlaceholder ? '#AAAAAA' : colors.BLACK)};
    text-transform: capitalize;
`;

export const Optional = styled.span`
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin: 0;
    color: ${colors.DARK_GREY};
`;

export const Menu = styled.ul`
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
    position: absolute;
    top: 100%;
    left: 0;
    margin: 0;
    margin-top: 3px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 1px 1px;
    padding: 12px 0;
    background-color: ${colors.WHITE};
    max-height: 460px;
    z-index: 1;
    box-sizing: content-box;
    width: inherit;

    &::-webkit-scrollbar {
        width: 18px;
    }

    &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 20px 20px #D9D9D6;
        border: solid 6px transparent;
        border-radius: 999px;
    } 

    &.panel-menu {
        top: 80px;
        box-shadow: none;
        max-height: none;
    }
`;

export const SubmenuContainer = styled.div`
    position: absolute;
    left: 100%;
    top: 0;
    width: max-content;
    padding-left: 2px;
    padding-top: 3px; 
    display: none;

    &.panel-submenu.is-active {
        display: block;
        position: static;
        width: 100%;

        & ul {
            box-shadow: none;
            padding: 4px 16px 32px 8px;
            width: 100%;

            & li p {
                padding: 8px 22px;
                width: 100%;
                color: #63666A;
                font-weight: 500;
                font-size: 1.6rem;
            }
        }
    }
`;

export const Submenu = styled.ul`
    padding: 8px 0;
    background-color: ${colors.WHITE};
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 1px 1px;
    overflow-y: overlay;
    max-height: 460px;
    margin: 0;

    &::-webkit-scrollbar {
        width: 18px;
    }

    &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 20px 20px #D9D9D6;
        border: solid 6px transparent;
        border-radius: 999px;
    }
`;

export const MenuItem = styled.li`
    position: relative;
    margin: 0;
    padding: 0;
    background-color: ${colors.WHITE};
    list-style: none;
    width: inherit;
    background-image: ${({ hasChildren }) => (hasChildren ? `url(${ChevronRight})` : 'none')};
    background-repeat: no-repeat;
    background-position: calc(100% - 20px) 16px;

    &:hover:not(.panel-menuitem) {
        background-color: #F2F2F2;

        ${SubmenuContainer} {
            display: flex;
        }
    }

    &.panel-menuitem {
        background-image:none;
        list-style: none;
        border-bottom: 1px solid #D9D9D6;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: end;
        box-sizing: border-box;

        &:after{
            content: '';
            width: 14px;
            height: 14px;
            position: absolute;
            right: 12px;
            top: 16px;
            background-image: ${({ hasChildren }) => (hasChildren ? `url(${ChevronDown})` : 'none')};
        }

        &.is-active:after{
            transform: rotate(180deg);
        }
    }
`;

export const MenuItemText = styled.p`
    padding: 12px 20px;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};
    margin: 0;
    display: block;
    width: 100%;
    border: none;
    text-align: left;
    cursor: pointer;
    text-transform: capitalize;
`;

export const DropdownContainer = styled.div`
    position: relative;
    width: inherit;
`;

export const DropdownButton = styled.button`
    background-repeat: no-repeat;
    background-position: calc(100% - 16px);
    background-image: url(${ChevronDown});
    width: 100%;
    border: 1px solid #63666A;
    border-radius: 1px;
    cursor: pointer;
    position: relative;
    background-color: ${colors.WHITE};
    padding: 0;
    text-align: left;
    min-height: 48px;

    &:focus {
        outline: auto;
        outline-color: #FFDFD0;
        outline-width: 3px;
        outline-offset: 2px;
        border-color: #D9D9D6;
    }
`;

export const SearchContainer = styled.li`
    border: 1px solid ${colors.GREY_MEDIUM};
    border-radius: 5px;
    margin: 5px 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    overflow: hidden;

    input:focus {
        outline: none;
    }

    &.search-menu {
        justify-content: space-between;
        margin-bottom: 18px;

        & img {
            padding-right: 12px;
        }
    }

`;

export const SearchBar = styled.input`
    padding: 15px 10px;
    font-size: 16px;
    border: none;
`;

export const SearchIcon = styled.img.attrs(() => ({ src: Search }))``;

export const CloseIcon = styled.img.attrs(() => ({ src: x_icon }))`
    cursor: pointer;
`;

export const Overlay = styled.div`
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    backdrop-filter: blur(2px);
    display: ${({ isPanelOpen }) => (isPanelOpen ? 'flex' : 'none')};

    ${MediaQuery.xLarge(css`
        display: none;
    `)};
`;

export const Panel = styled.div`
    width: 100%;
    display: ${({ isOpen }) => (isOpen ? 'grid' : 'none')};
    position: fixed;
    overflow-y: auto;
    right: 0;
    top: 40px;
    bottom: 0;
    background-color: ${colors.WHITE};
    padding: 10px 0;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 40px;
    z-index: 4;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #D9D9D6;
`;

export const CloseButtonContainer = styled.button`
    * {
        pointer-events: none;
    }

    display: flex;
    background-color: transparent;
    border: none;

    &:hover {
        cursor: pointer;
    }

    margin-right: 20px;

    ${MediaQuery.xLarge(css`
        display: none;
    `)}
`;
